import Image from "next/image"
import upscbanner1 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
import MobBanner from "../../assets/images/home/Banner/UPSC-CSE-2025-Webbanner.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import downloadicon from "../../assets/images/download.png";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import Link from "next/link";
import Head from "next/head";
import Emioption from "../../components/Service/emioption";
import useDownloader from "react-use-downloader";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {

  const {download} = useDownloader();

  const fileUrl = "/pdf/admission/SIA-Brochure-2025-Annanagar.pdf";
  const filename = "SIA-Brochure-2025-Annanaga.pdf"

  const feestructure =[
    {date:"23.04.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    // {date:"06.06.2025", cont:"Regular", cont1:"09:30 am to 12:30 pm"}
  ]

  const feestructure2 =[
    {date:"18.06.2026", cont:"Regular", cont1:"02:30 pm to 04:30 pm"},
    
  ]
   const feestructure3 =[
     {date:"05.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Public Administration",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"PSIR",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
     
   
  ]

  const jsonLd ={
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "IAS Coaching in Hyderabad | Shankar IAS Academy",
        "url": "https://www.shankariasacademy.com/hyderabad/",
        "Image":
        "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
        "description": "Achieve UPSC greatness with best IAS Coaching in Hyderabad. Comprehensive curriculum, dedicated faculty, and a history of success await you."
  }
  const router = useRouter();
  

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);
  return (
    <>
     <Head>
     
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-KK7QL7XRX3"></script>
        <script>
          {
          `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-KK7QL7XRX3');
          `
          }
        </script>

                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>IAS Coaching in Hyderabad | Shankar IAS Academy</title>
                <meta name="title" content="IAS Coaching in Hyderabad | Shankar IAS Academy" />
                <meta name="description" content="Achieve UPSC greatness with best IAS Coaching in Hyderabad. Comprehensive curriculum, dedicated faculty, and a history of success await you." />
                <link rel="canonical" href="https://www.shankariasacademy.com/hyderabad/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="IAS Coaching in Hyderabad | Shankar IAS Academy" />
                <meta property="og:description" content="Achieve UPSC greatness with best IAS Coaching in Hyderabad. Comprehensive curriculum, dedicated faculty, and a history of success await you." />
                <meta property="og:url" content="https://www.shankariasacademy.com/hyderabad/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
                <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
              </Head>

      <Navbar title="upsc" />

                <div className="container">
                    <div className="row">
                       <div className="col pt-3 pt-md-4">
                            <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
                                <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4" type="button">Anna Nagar</button></Link>
                                <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Adyar</button></Link>
                                <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Bengaluru</button></Link>
                                <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Coimbatore</button></Link>
                                <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Delhi</button></Link>
                                <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 active" type="button">Hyderabad</button></Link>
                                <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Thiruvananthapuram</button></Link>
                                <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
                                <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Salem</button></Link>
                                <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
                                <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4" type="button">Online Class</button></Link>
                                <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <h1 className={`${styles.pagemaintitle}`}>UPSC - Classroom & Online - Hyderabad</h1>
                            
                        </div>
                        <div className="row d-none d-md-block">
                    <div className="col pt-3 pt-md-5">
                        <Image src={upscbanner1} alt="UPSC Coaching in Hyderabad" title="UPSC - Classroom & Online - Hyderabad" className="img-fluid w-100"/>
                    </div>
                </div>

                <div className="row d-block d-md-none">
                    <div className="col pt-3 pt-md-5">
                        <Image src={MobBanner} alt="UPSC Coaching in Hyderabad" title="UPSC - Classroom & Online - Hyderabad" className="img-fluid w-100"/>
                    </div>
                </div>
                    </div>
                </div>

{/* <Classroom_form branchname="Hyderabad" /> */}
<div className="container pb-5">
<div className={`${styles.coursesimg} mb-2`}>
  <div class="col-12 col-md-6 offset-md-3 mt-4">
  <p className={`${styles.contactheader} text-center`}>Enquiry</p>
  <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
  <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
  </div>
  </div>
</div>

 <div className="container-fluid">
        <div className={`${styles.bestbg1}`}>
          <div className="row g-4 mt-2">
            <div className="col-12 col-md-6 col-lg-12">
              <div className="card shadow-sm p-4">
                <h2> <span style={{fontSize:"20px",color:'#db1b0d' ,fontWeight:"bold"}}>Pre Booking Open</span></h2> 
                <p>
                  For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>93902 42708</span> 
                </p>
                 <div className={`${styles.brochure} justify-content-center`}>
                              <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Hyderabad-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                                  <button className={`${styles.normalbutton1} btn btn-danger`}>
                                   <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                                  </button>
                              </a>
                  </div>
              </div>
                
            </div>   
          </div>
        </div>
  </div>
<div className="container">
      <div className="row pt-2">

      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
    
        <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
            <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,38,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
         
      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
              <tr>
             
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>
    

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        
         <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>CSAT</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>14,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
          

      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure2.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
            <tr>
             
            </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>


      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
           <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>Optional</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>34,000</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>


        <div className="pt-3" id="paymentsection">       
         <div className="row mx-auto">
          <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
          <table className="table ">
            <tbody>
            {feestructure3.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
              </tr>
              ))}
              {/* <tr>
               <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td>
              </tr> */}
              <tr>
            
              </tr>
            </tbody>
          </table>
          </div>
          </div>   
        </div>
      </div>
     
      </div>
               <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
                  <ObtionalButton />
              </div>
              

       <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
                  <p className={`${styles.sectionsubtitle} `}>Total Amount </p>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 py-2">
                    <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle}`}><b>₹</b>1,86,000*</span><span>(inclusive of tax)</span></span>
                    
                </div>

              

                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
                   <Emioption />
                   
               </div>   

               <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
                 <a href="https://admissionsv1.shankariasacademy.com/" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
               </div>


      </div>
<div className={`${styles.sadhana}`}>
<div className="container">
  <div className="row">

  {/* <div className="col-12 col-md-4 text-white mt-2 p-2">
    UPSC GS-Mains Test Series 2025 (Moksha)<br />
    <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
    </div> */}

 <div className="col-12 offset-md-4 col-md-4 p-2">
    <Link href="/two-year-upsc-program">
      <Image alt="sadhana" className="img-fluid" src={sadhana} />
    </Link>
  </div>

  {/* <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
     <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
        <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
      </button>
 </div> */}
  
 
 
</div>
</div>
</div>
      <Program_Features />

      {/* Our Acheivers */}
      <div className="container">
        <div className="row">
          <div className="col pt-4 pt-md-5 text-center">
            <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
            <p className={`${styles.sectionsubtitle}`}>
              Rank Holders from our academy
            </p>
          </div>
        </div>
      </div>

      <Acheiver />
       
      <section id="toppers">
        <div className="container">
          <div className="row">
            <div className="  col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
            <Optionalplus /> 
            </div>
          </div>
        </div>
     </section>

     

  {/* CSAT Program */}
    {/* <div className="container py-4">
        <div className="col-12">
          <div className="csattable">
            <div className="row csathead">
              <div className="col-12 col-lg-2">
                  <p className={`${styles.tableheading1} mb-0`}>CSAT Revision</p>
              </div>
              <div className="col-12 col-lg-4">
                  <p className={`${styles.tablepara1} mb-0`}>20th May 2024 (Offline & Online)<br/>(	08:00 am to 10:00 am)</p>
              </div>
              <div className="col-12 col-lg-2">
                  <p className={`${styles.tablepara1} mb-0`}>₹ 1000</p>
              </div>
              <div className="col-12 col-lg-4">
                  <p  className={`${styles.tablepara1} mb-0`}>Admission - <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></p>
              </div>
            </div>
          </div>
        </div>
    </div> */}



{/* Fee Details Section */}

 
  
      {/* <div className="row pt-3">
         <a href="https://admissionsv1.shankariasacademy.com/Prebooking-Forms/Step1/step1?center=ANNA_NAGAR&&course=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pre Booking</button></a>
          <button type="button" className={`${styles.normalbutton} ms-3`} onClick={()=>router.push({pathname:"/Prebooking-Forms/Step1/step1",query:"center=ANNA NAGAR&course=UPSC"
             })}>Pre Booking</button> 
              <button type="button" className={`${styles.normalbutton} ms-3`}>Pre Booking</button> 
     </div> */}
{/*      
     <div className="row">
      <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹10,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p>
      </div> 
      <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
      </div>
     </div>  */}





          {/* <div className="row pt-3 prelimstable">
            <div className="col">
              <div className={`${styles.tablescroll}`}>
                <table className="table">
                  <thead className="table" style={{ backgroundColor: "#818C98" }}>
                    <tr>
                      <td className={`${styles.tableheading}`}>Date<br /></td>
                      <td className={`${styles.tableheading}`}>Batch<br /></td>
                      <td className={`${styles.tableheading}`}>Time<br /></td>
                      <td className={`${styles.tableheading}`}>Admission<br /></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="pt-2">
                      <td className={`${styles.tablepara}`}>09.12.2023<br /></td>
                      <td className={`${styles.tablepara}`}><p className={`${styles.tablepara}`}>Regular (Offline/Online)</p></td>
                      <td className={`${styles.tablepara}`}><p className={`${styles.tablepara}`}>08.00 am to 1.00 pm</p></td>
                      <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay now</button></Link></td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>  */}



          {/* <div className="row pt-3">
         <a href="https://admissions.shankariasacademy.com/sianew/prebooking/courseinfo?center=Anna%20Nagar&course=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Now</button></a>
     </div> */}

          {/* <div className="row">
      <div className="col-md-12 col-lg-8 col-xl-7 col-12 pt-3 pe-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹5,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p>
      </div> 
      <div className="col-md-12 col-lg-6 col-xl-5 col-12 pt-3 ps-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
      </div>
     </div> */}

        </div>
</div> 
      

      {/* Location Section */}

      {/* <div className="container">
        <div className="row pt-3">
          <div className="col">
            <h2 className={`${styles.sectiontitle} mb-2`}>Venue</h2>
            <p className={`${styles.sectionsubtitle} mb-1`}>Shankar IAS Academy</p>
            <p className={`${styles.acheiverrank} mb-0`}>No.302,Sriman Aishwarya Towers,</p>
            <p className={`${styles.acheiverrank} mb-0`}>Municipal No :1-2-234/13/45/B,</p>
            <p className={`${styles.acheiverrank} mb-0`}>Domalguda,</p>
            <p className={`${styles.acheiverrank}`}>Hyderabad - 500029.</p>
          </div>
          <p className={`${styles.acheivername}`}><Image src={phone} alt="Shankar IAS Academy salem contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:83091 25825" className={`${styles.numberbold}`}>83091 25825</a></p>
          <a href="https://www.google.com/maps/place/Shankar+IAS+Academy+Hyderabad/@17.4091647,78.4871178,17z/data=!4m6!3m5!1s0x8322f8764aad961:0xf0a187bddb107656!8m2!3d17.4095297!4d78.4878647!16s%2Fg%2F11kqm5fnmd?entry=ttu" target="_blank" rel="noreferrer" className={`${styles.redunderlinealink}`} style={{ whiteSpace: "nowrap" }}>Get Direction</a>
        </div>
      </div> */}

<div style={{
        background: "#F4F6F8 0% 0% no-repeat padding-box",
        opacity: "1"
      }}>
        <div className="container">
          <div className="row pt-md-5 pt-3 mb-0">
            <div className="col-xl-6 col-12 pt-2">
            <p className={`${styles.hyderabadcon}`}>Are you aspiring to join the prestigious <span  className={`${styles.program1}`}> Indian Administrative Services (IAS)</span>  and looking for the best coaching institute in Hyderabad to guide you through your journey? Your search ends here! Welcome to our top-notch <span><Link className={`${styles.program1}`} href="/"> Shankar IAS Academy </Link></span>  Coaching Centre, where we offer unrivaled guidance and support tailored specifically for aspirants like you.</p>
              <p className={`${styles.hyderabadcon}`}>Our institute stands out as a beacon of excellence in <b>Best IAS Coaching in Hyderabad</b>, committed to empowering you to conquer the UPSC exam with confidence and success.</p>
              <h2 className={`${styles.hyderabadtitle} mb-2`}>About Us: Your Premier IAS Academy</h2>
              <p className={`${styles.hyderabadcon} mb-0`}>Established with the vision of nurturing future civil servants, our <span><Link className={`${styles.program1}`} href="/"> IAS Academy in Hyderabad </Link></span>  is renowned for its excellence in coaching and comprehensive study materials. The academy has evolved over the years to the extent of successfully helping over 2200+ candidates realize their dream of becoming bureaucrats and successfully guiding thousands of others to realize their potential. We take pride in having successfully contributed to nation building in a small way.</p>
              <p className={`${styles.hyderabadcon} pt-3`}>Our faculty comprises seasoned educators and experienced trainers who are committed to providing unparalleled guidance and support to every aspirant. With their vast experience and expertise, they ensure that you receive the highest quality instruction and mentorship tailored to your individual needs.</p>
              <p className={`${styles.hyderabadcon} pt-3`}> We understand that the journey to becoming an IAS officer is challenging, which is why we prioritize creating a supportive and nurturing learning environment by regularly conducting student-achiever interactions. Whether you're a beginner taking your first steps towards your goal or a seasoned aspirant seeking to refine your skills, our academy is here to guide you at every stage of your preparation. </p>
            </div>
            <div className="col-xl-6 col-12 pt-2">
               <Image src="/images/Hyderabad.webp" alt=" IAS Coaching in Hyderabad" class="img-fluid" width={1067} height={654} />
            </div>
          </div>
          <div className="row pt-3">
            <div className="col-lg-11 col-md-11 col-12">
              <h2 className={`${styles.hyderabadtitle} mb-2`}>Our Offerings: Unmatched IAS Coaching Centre in Hyderabad</h2>
              <h3 className={`${styles.hyderabadtitle1} mb-2`}>Comprehensive UPSC Curriculum</h3>
              <p className={`${styles.hyderabadcon}`}>Our coaching center offers a meticulously designed curriculum that covers all subjects and topics prescribed by the UPSC. From General Studies to Optional subjects, we ensure comprehensive coverage to equip you with the knowledge and skills required to excel in the exam.</p>
              <h3 className={`${styles.hyderabadtitle1} mb-2`}>Expert Faculty</h3>
              <p className={`${styles.hyderabadcon}`}>Our faculty members are seasoned experts in their respective fields, including retired civil servants, subject matter experts, and experienced educators. They bring a wealth of knowledge and experience to the classroom, providing insightful guidance and mentoring to every student.</p>

              <h3 className={`${styles.hyderabadtitle1} mb-2`}>Personalized Attention</h3>
              <p className={`${styles.hyderabadcon}`}>We understand that every aspirant has unique strengths and weaknesses. That's why we provide personalized attention to each student, offering individualized coaching, doubt-clearing sessions, and mentorship to address specific needs and challenges.</p>
               
              <h3 className={`${styles.hyderabadtitle1} mb-2`}>Strategic Approach</h3>
              <p className={`${styles.hyderabadcon} mb-2`}>Cracking the UPSC exam requires more than just academic knowledge; it requires a strategic approach. Our coaching methodology focuses on developing critical thinking, analytical skills, and effective exam strategies to maximize your chances of success.</p>
              
              <h3 className={`${styles.hyderabadtitle1} mb-2`}>Regular Mock Tests and Feedback</h3>
              <p className={`${styles.hyderabadcon} mb-2`}>To assess your progress and readiness for the exam, we conduct regular mock tests that simulate the UPSC exam environment. These tests help identify areas of improvement and provide valuable feedback to enhance your performance.</p>

              <h2 className={`${styles.hyderabadtitle} mb-2`}>Admission Process: Join the Best UPSC Coaching in Hyderabad</h2>
              <p className={`${styles.hyderabadcon} pt-2`}>Enrolling in our IAS Coaching Centre is easy! Simply follow these steps to kickstart your journey towards becoming an IAS officer:</p>
              
              <h3 className={`${styles.hyderabadtitle1} mb-2`}>Contact Us</h3>
              <p className={`${styles.hyderabadcon}`}> <span><Link className={`${styles.program1}`} href="https://www.shankariasacademy.com/contact-us/"> Get in touch </Link></span> with our admission team either through phone, email, or by visiting our Academy in person.</p>

              <h3 className={`${styles.hyderabadtitle1}`}>Consultation</h3>
              <p className={`${styles.hyderabadcon}`}> <span><Link className={`${styles.program1}`} href="https://www.shankariasacademy.com/admission-consultation/"> Schedule a consultation </Link></span> with our academic counselors to discuss your goals, aspirations, and the best course of action for your UPSC preparation.</p>
               
              <h3 className={`${styles.hyderabadtitle1}`}>Registration</h3>
              <p className={`${styles.hyderabadcon}`}>Complete the registration process by filling out the necessary forms and submitting the required documents.</p>
               
              <h3 className={`${styles.hyderabadtitle1}`}>Orientation</h3>
              <p className={`${styles.hyderabadcon}`}>Attend an orientation session where you'll get acquainted with our coaching methodology, faculty members, study materials, and other resources available at our institute.</p>
               
              <h3 className={`${styles.hyderabadtitle1}`}> Start Learning </h3>
              <p className={`${styles.hyderabadcon}`}>Once enrolled, dive into our comprehensive study materials, attend interactive classes, and participate in mock tests to kickstart your UPSC preparation journey.</p>
              
              <h2 className={`${styles.hyderabadtitle}`}> Join Us Today and Fulfill Your Dreams! </h2>
              <p className={`${styles.hyderabadcon}`}> Don't let the opportunity to join the best <span><Link className={`${styles.program1}`} href="/">  IAS Coaching in Hyderabad </Link></span> slip away! With our expert guidance, personalized attention, and proven track record of success, you'll be well-equipped to ace the UPSC exam and embark on a fulfilling career in public service. </p>
              <p className={`${styles.hyderabadcon}`}> <span><Link className={`${styles.program1}`} href="https://admissionsv1.shankariasacademy.com/Prebooking-Forms/Step1/step1?center=DELHI&&course=UPSC"> Enroll now </Link></span>  and take the first step towards realizing your aspirations of serving the nation as an IAS officer. </p>
            </div>
          </div>
        </div>
      </div>

      <BranchAddress />
      <Interest />
      <Footer />
    </>
  )
}

export default UPSCClassroomOnline;
